import { axiosGet, axiosPost } from "../../react_axios/Axios"
import { headers, getTaxInvoiceListUrl, GET_TAXINVOICE_LIST_ACTION, taxInvoiceRpt, fetchAuthReport, GET_INVOICE_RPT_ACTION_TYPE, shareTaxInvoiceUrl, SHARE_TAXINVOICE_ACTION } from "../../utils/constants"

export const get_taxInvoiceList_action = (CompanyName, TaxInvoice_No, Membershipno) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: sessionStorage.getItem('UserIDSS') != '' && sessionStorage.getItem('UserIDSS') != null ? sessionStorage.getItem('UserIDSS') : null,
            MemberID: sessionStorage.getItem('RoleIDSS') == 5 ? sessionStorage.getItem("MemberIDSS") : null,
            CompanyName: CompanyName ? CompanyName : null,
            TaxInvoice_No: TaxInvoice_No ? TaxInvoice_No : null,
            Membershipno: Membershipno ? Membershipno : null
        }
        console.log(CompanyName, TaxInvoice_No, Membershipno,mapdata)
        const res = await axiosGet(getTaxInvoiceListUrl, mapdata, headers);

        dispatch({
            type: GET_TAXINVOICE_LIST_ACTION,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const taxInvoiceRpt_action = (MemberID) => async (dispatch) => {
    try {
        var list = [];
        const mapdata1 = {
            "ParameterName": "@MemberID",
            "ParameterValue": MemberID,
            "ParameterDataType": "int"
        }
        list.push(mapdata1);
        const mapData = {
            "report_name": taxInvoiceRpt,
            "parameter_details": list
        }
        const res = await axiosPost(fetchAuthReport, mapData);
        dispatch({
            type: GET_INVOICE_RPT_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const share_taxInvoice_action = (MemberID, TaxInvoice_No) => async (dispatch) => {
    try {
        const mapdata = {
            MemberID: MemberID,
            TaxInvoice_No: TaxInvoice_No,
        }

        const res = await axiosGet(shareTaxInvoiceUrl, mapdata, headers);
        console.log("share_credential_action res", res)

        dispatch({
            type: SHARE_TAXINVOICE_ACTION,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
}
